<template>
  <div class="h-screen flex items-center justify-center bg-white">
    <div class="text-center">
      <p class="text-xl font-medium text-gray-600">Yönlendiriliyorsunuz...</p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  error: Object,
});

// Server-side redirect
if (process.server) {
  const event = useRequestEvent();
  if (event) {
    sendRedirect(event, "/", 301);
  }
}

// Client-side redirect
onMounted(() => {
  clearError({ redirect: "/" });
});
</script>
